import { useQuery } from '@tanstack/react-query'
import { getSalesforceProjectMembers } from '@/lib'
import { queryKeys } from '@/lib/queryKeys'

interface UseSalesforceProjectMembersOptions {
  enabled?: boolean
  offset?: number
  limit?: number
}

/**
 * Salesforceプロジェクトメンバー一覧を取得するカスタムフック
 *
 * @param salesforceProjectId - SalesforceプロジェクトID
 * @param options - フックオプション
 * @returns TanStack Query の結果
 */
export function useSalesforceProjectMembers(
  salesforceProjectId: number | null | undefined,
  options: UseSalesforceProjectMembersOptions = {},
) {
  const { enabled = true, offset, limit } = options

  return useQuery({
    queryKey: queryKeys.salesforceProjectMembers(salesforceProjectId, { offset, limit }),
    queryFn: async () => {
      if (!salesforceProjectId) {
        throw new Error('SalesforceプロジェクトIDが指定されていません')
      }
      return getSalesforceProjectMembers(salesforceProjectId, { offset, limit })
    },
    enabled: enabled && !!salesforceProjectId && salesforceProjectId > 0,
  })
}
